export const CHANNEL = Object.freeze({
  EMAIL: 'email',
  SMS: 'sms',
  MMS: 'mms',
});

export const TEMPLATE_TYPE = Object.freeze({
  MARKETING: 'marketing',
  TRIGGER: 'trigger',
});

export const TEMPLATE_STATUS = Object.freeze({
  DRAFT: 'draft',
  PUBLISHED: 'published',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
});

export const TRIGGER_CHANNEL = Object.freeze({
  EMAIL: 'email',
  TEXT: 'text',
});

export const TEMPLATE_LANGUAGE = Object.freeze({
  ENGLISH: 'en',
  SPANISH: 'es',
});

export const TEMPLATE_LANGUAGE_LABEL = Object.freeze({
  [TEMPLATE_LANGUAGE.ENGLISH]: 'English',
  [TEMPLATE_LANGUAGE.SPANISH]: 'Spanish',
});
